import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './DynamicTexts.module.scss';

type DynamicTextsProps = {
  texts: string[];
  delay?: number;
  stopOnLast?: boolean;
  className?: string;
};

const DynamicTexts: React.FC<DynamicTextsProps> = ({
  texts,
  delay = 6000,
  stopOnLast = false,
  className,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (stopOnLast && currentIndex === texts.length - 1) {
        clearInterval(interval);
        return;
      }

      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, delay);

    return () => clearInterval(interval);
  }, [texts.length, delay, stopOnLast, currentIndex]);

  return (
    <p
      key={currentIndex}
      className={classNames(styles.text, className)}>
      {texts[currentIndex]}
    </p>
  );
};

export default DynamicTexts;
